var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.input.label)?_c('h3',[_vm._v(_vm._s(_vm.input.label))]):_vm._e(),_vm._v(" "),_c('div',{domProps:{"textContent":_vm._s(_vm.input.value)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }